import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleRecaptchaService } from '../../services/google-recaptcha/google-recaptcha.service';
import { ToastService } from '../../services/toast/toast.service';
import { ChangePasswordService } from '../../services/change-password/change-password.service';
import { Component, OnInit, Input, ViewChild, ElementRef, HostListener,  DestroyRef,   inject } from '@angular/core';
import { NgbDropdown, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SessionMgmtService } from '../../services/session-mgmt/session-mgmt.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LoginService } from '../../services/login/login.service';
import { APP_CONST } from 'src/app/shared/constants/app-constants';
import { HeaderService } from '../../services/header/header.service';
import { GlobalFilterService } from '../../services/filters/global-filter.service';
import { AccountsService } from '../../services/accounts/accounts.service';
import { Subscription } from 'rxjs';
import { TrendsService } from '../../services/trends/trends.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { DownloadService } from '../../services/downloads/download.service';
import { HolidayCalendarComponent } from '../holiday-calendar/holiday-calendar.component';
import { ManagersService } from '../../services/managers/managers.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { LtmsDaterangePickerComponent } from '../ltms-daterange-picker/ltms-daterange-picker.component';
import { ChangeAccessLevelComponent } from '../../../features/manager/change-access-level/change-access-level.component';
import { TranslateModule } from '@ngx-translate/core';
@Component({
    selector: 'app-litmus-header',
    templateUrl: './litmus-header.component.html',
    styleUrls: ['./litmus-header.component.scss'],
    imports: [NgIf, HolidayCalendarComponent, NgClass, NgStyle, NgFor, NgbTooltip, LtmsDaterangePickerComponent, FormsModule, ReactiveFormsModule, ChangeAccessLevelComponent, TranslateModule]
})
export class LitmusHeaderComponent implements OnInit {
  accountsDetails: any;
  currentUrl: string;
  passwordResetForm!: FormGroup;
  submitted = false;
  reCAPTCHAToken = "";
  userName = "";
  showModel = false
  isWrongPassword = false;
  invalidCurrentPassword = false;
  showConfirmPassword = false;
  showNewPassword = false;
  showConfirmPasswordEye = false;
  showNewPasswordEye = false;
  headerState: any = {};
  signedInAsVisible = true;
  changeAccessLevelVisible = true;
  headerStateSubscription: Subscription | undefined;
  @Input() showCalendarButton = true;
  @Input() showUserButton = true;
  @Input() showChangeAccessLevelButton = false;
   destroyRef = inject(DestroyRef);
  dropdownVisible = false;
  @ViewChild(NgbDropdown) dropdown: NgbDropdown | undefined;
  calendar = false;
  changeAccessLevelContainerVisible = false;
  selectedRange = '';
  requestDate = true;
  isFullScreen = false;
  fullScreenButtonText: string = 'View Fullscreen';
  logoUrl: string | undefined;
  isDownloadSideBarOpen: boolean = false
  selectedProjectType: string = '';
  isProjectTypeOpen: boolean = false;
  projectTypeOptions: any = [];
  isShowProject: boolean = false;
  isProjectPage: boolean = false;
  @ViewChild('threeDotContainer') threeDotContainer!: ElementRef;
  @ViewChild('userProfile') userProfile!: ElementRef;
  @ViewChild('breadCrumbDropdown') breadCrumbDropdown!: ElementRef;
  
  isProfileDropdownVisible: boolean = false;
  name_logo: string = '';
  fullName: string = '';
  email_address: string = '';
  isBreadcrumbVisible: boolean = false;
  breadcrumbAccount: any = {};
  breadcrumbProject: any = {};
  breadcrumbProjectStatus: any = {};
  breadcrumbTab: string = '';
  isHideAccountName: boolean = false;
  isHideProjectName: boolean = false;
  showLoader = false;
  removeClickEventFromAccount: boolean = false;
  removeClickEventFromProject: boolean = false;
  isAccountsRoute: boolean = false
  isUppercaseValid = false;
  isLowercaseValid = false;
  isNumberValid = false;
  isSpecialCharValid = false;
  loaderMessage: string = '';
  isLengthValid = false;
  isNewPasswordValidate = false;
  isConfirmPasswordValidate = false;
  newPasswordValue = "";
  confirmPasswordValue = "";
  currentPassword = "";
  isSubmitButtonDisable: boolean = true;
  accountID: string = '';
  isCalendarActive: boolean = false;
  restrictedDate: any = null;
  isHolidayListOpen: boolean = false;
  isProjectLevelConversationPreview = false;
  conversationPreviewURL = '';
  isHolidayListVisible: boolean = false;
  isBillingDashboard: boolean = false
  showChangePasswordButton: boolean = true;
  statusMap: any = {
            1: 'Set Up',
            2: 'Live',
            3: 'Closed',
            4: 'Archive',
            6: 'On Hold'
          };
  constructor(
    private sessionManager: SessionMgmtService,
    public fb: FormBuilder,
    private googleRecaptchaService: GoogleRecaptchaService,
    private _toast: ToastService,
    private changePasswordService: ChangePasswordService,
    private router: Router,
    private loginService: LoginService,
    public headerService: HeaderService,
    private accountsService: AccountsService,
    private route: ActivatedRoute,
    private trendsService: TrendsService,
    private globalFilterService: GlobalFilterService,
    private helpersService: HelpersService,
    private downloadService: DownloadService,
     private managersService: ManagersService,
     
  ) {
    this.currentUrl = this.router.url;
  }


  // This function will enable the flag for open user setting pop up
  openModal(): void {
    this.isProfileDropdownVisible = !this.isProfileDropdownVisible;
    this.showModel = true;
  }

  // Call the logout function from LogoutService
  logout() {
    this.setCursor('wait', 'logoutbtn')
    this.loginService.logoutUserApi({}).subscribe(
      {
        next: (response) => {
          Helpers.resetAppState('full_reset');
          this.loginService.gotoLogout();
          this.setCursor('pointer', 'logoutbtn');
        },
        error: (e) => {
          this.setCursor('pointer', 'logoutbtn');
          console.error('Error in API call in logout:', e);
        },
        complete: () => {
          this.setCursor('pointer', 'logoutbtn');
          console.log("Logout completed.");
        }
      }
    );
  }

  setCursor(cursorStyle: string, elementId?: string): void {
    // You can apply the cursor style to the entire body or specific elements
    try {
      if (elementId == 'logoutbtn') {
        let selectedBrand = document.getElementById(elementId);
        if (selectedBrand) {
          selectedBrand.style.cursor = cursorStyle;
        }
      } else {
        document.body.style.cursor = cursorStyle;
      }
    } catch (error) {
      console.log("Error while setting up cursor, Error: ", error)
    }
  }

  // This function will enable the flag for close user setting pop up
  closeModal(): void {
    this.showModel = false;
    this.isWrongPassword = false;
    this.invalidCurrentPassword = false;
    this.showConfirmPasswordEye = false;
    this.isSubmitButtonDisable = true;
    this.showNewPasswordEye = false;
    this.isNewPasswordValidate = false;
    this.passwordResetForm.reset();
  }

  onPasswordInputChange(password) {
    this.isWrongPassword = false;
    this.invalidCurrentPassword = false;
    this.confirmPasswordValue = this.passwordResetForm.get('confirm_password')!.value;
    this.currentPassword = this.passwordResetForm.get('current_password')!.value;
    if (password == 'new_password') {
      this.newPasswordValue = this.passwordResetForm.get('new_password')!.value;
      if (!_.isEmpty(this.newPasswordValue)) {
        this.isNewPasswordValidate = this.passwordValidator(this.newPasswordValue)
      }
    }
    if (this.currentPassword && this.currentPassword.length && this.newPasswordValue && this.newPasswordValue.length && this.confirmPasswordValue && this.confirmPasswordValue.length) {
      this.isSubmitButtonDisable = false;
    } else {
      this.isSubmitButtonDisable = true;
    }
    // else if (password == 'confirm_password') {
    //   this.confirmPasswordValue = this.passwordResetForm.get('confirm_password')!.value;
    //   if (!_.isEmpty(this.confirmPasswordValue)) {
    //     this.isConfirmPasswordValidate = this.passwordValidator(this.confirmPasswordValue)
    //   }
    // } 
  }

  passwordValidator(password) {
    this.isUppercaseValid = /[A-Z]/.test(password);
    this.isLowercaseValid = /[a-z]/.test(password);
    this.isNumberValid = /\d/.test(password);
    this.isSpecialCharValid = /[!@#$%^&*()_+\[\]{};':"|?/]/.test(password);
    this.isLengthValid = password.length >= 8;

    if (this.isUppercaseValid && this.isLowercaseValid && this.isNumberValid && this.isSpecialCharValid && this.isLengthValid) {
      return true;
    } else {
      return false;
    }
  }

  // Based on the selected eye icon of input element it will show the entered password
  showPassword(btn): void {
    if (btn && btn == "newPassword") {
      this.showNewPassword = !this.showNewPassword
      this.showNewPasswordEye = !this.showNewPasswordEye
    } else if (btn && btn == "confirmPassword") {
      this.showConfirmPassword = !this.showConfirmPassword
      this.showConfirmPasswordEye = !this.showConfirmPasswordEye
    }
  }

  ngOnInit() {
    this.headerService.toggleChangeAccessLevelButtonVisibility(this.showChangeAccessLevelButton); // If reload the page then set current flag
    this.isCalendarActive = false
    this.currentUrl = this.router.url;
    this.isAccountsRoute = this.currentUrl === '/accounts';
    this.updateHolidayListVisibility();
    this.breadcrumbInitiate();
    this.setLoginTypeFromAccountDetails();
    this.router.events.subscribe((event) => {
      this.breadcrumbInitiate();
      if (event instanceof NavigationEnd) {
        this.currentUrl = this.router.url;
        this.isAccountsRoute = this.currentUrl === '/accounts'
        this.updateHolidayListVisibility();
      }
    });

    if (this.route.snapshot.queryParams) {
      // Set account_id and project_id from route for global use thru service 
      this.globalFilterService.setValuesForGlobalUse(this.route.snapshot.queryParams);
    }
    this.downloadService.showSideBar.subscribe((flag: boolean) => {
      this.isDownloadSideBarOpen = flag;
    });
    window['Helpers'] = this.helpersService.consoleData();
    this.passwordResetForm = new FormGroup({
      current_password: new FormControl(),
      new_password: new FormControl(),
      confirm_password: new FormControl(),
    })
    this.getManagerDetails()

    if (this.currentUrl === "/accounts") {
      this.showCalendarButton = false;
    }
    this.getQueryParams()
    this.headerService.headerState$.subscribe((state) => {
      this.headerState = state;
      this.doOperation(this.headerState)
    });
    this.headerStateSubscription = this.headerService.headerState$.subscribe(state => {
      this.headerState = state;
    });
    this.exitFullScreenListener();
  }

  openHolidayList(event:Event) {
    event.stopPropagation()
    this.isHolidayListOpen = true;
    this.dropdownVisible = false
  }
  closeHolidayList() {
    this.isHolidayListOpen = false
  }

  updateHolidayListVisibility() {
    const holidayList = Helpers.brandDetails?.conversation_config?.actions?.business_timings?.holidays;
    this.isHolidayListVisible = this.currentUrl.includes('/project') && Array.isArray(holidayList) && holidayList.length > 0;
  }

  gotoHome() {
    this.loginService.gotoAccounts()
  }
  gotoDashboard(accountId: string) {
    this.router.navigate([APP_CONST.ROUTE_ACCOUNT_DETAILS], {
      queryParams: { account_id: accountId }
    });
  }

  gotoProject(accountId: string, projectId: string, activeTab: string = 'trends') {
    this.router.navigate([APP_CONST.ROUTE_PROJECT_DETAILS], {
      queryParams: {
        account_id: accountId,
        project_id: projectId,
        active_tab: activeTab
      }
    });
  }
  
  gotoAccounts() {
    this.router.navigate([APP_CONST.ROUTE_ACCOUNTS]);
  }
  gotoLogin() {
    this.router.navigate([APP_CONST.ROUTE_LOGIN]);
  }

   userCurrentAccess() {
     // this.showMainContent = false;
      this.loaderMessage = 'Checking login status...';
    
       const manager = this.helpersService.helpers['managerDetails']?.manager;
       //Here no need to check lw3 permission, as this is already checked in auth.guard.ts
            if (manager && manager._id) {
              // Delegate redirection logic to managersService.getAccess
              this.managersService.getAccess(manager, {
                gotoProject: (accountId, projectId) => this.gotoProject(accountId, projectId),
                gotoDashboard: (accountId) => this.gotoDashboard(accountId),
                gotoAccounts: () => this.gotoAccounts(),
                logoutUser: () => this.logoutUser(),
                setError: (msg) => this.setError(msg),
                setShowLoader: (val) => this.showLoader = val,
                setLoaderMessage: (msg) => this.loaderMessage = msg,  // <- added
              });
            } else {
              this.router.navigate([APP_CONST.ROUTE_LOGIN]);
              this.loaderMessage = 'Redirecting to login...';
             // this.showMainContent = true;
            }
  } 

  setError(message: string) {
    
    
  }
  logoutUser() {
    try {
      const reqBody = {};
      this.loginService.logoutUserApi(reqBody).subscribe(
        (response) => {
          // Additional cleanup logic
        },
        (error) => {
          console.error('Error in API call in logout:', error);
        }
      );
    } catch (error) {
      console.error('Error occurred in logout:', error);
    }
  }
  toggleDownloadSideBar(event: any) {
    event.stopPropagation()
    this.dropdownVisible = !this.dropdownVisible;
    this.downloadService.showDownloadSideBar(!this.isDownloadSideBarOpen)
  }
  getQueryParams() {
    this.route.queryParams.subscribe((params) => {
      const accountId = params['account_id'];
      const projectId = params['project_id'];
      if (projectId) {
        this.getBrandDetail(projectId);
        this.setProjectTypeForProject();
        this.logoUrl=_.get(Helpers,"brandDetails.logo_url","assets/images/litmusworld.svg")
      } else if (accountId && this.accountID != '' && this.accountID == accountId) {
        // console.log("Nothing will change....");
        // this.getAccountDetail(accountId);
      } else if (accountId) {
        this.accountID = accountId;
        this.logoUrl=_.get(Helpers,"accountDetails.logo_url","assets/images/litmusworld.svg")
        // this.getAccountDetail(accountId);
        this.setProjectTypeForAccount(accountId); // Orange label next to the LW logo in the header.
      }else{
        this.logoUrl= 'assets/images/litmusworld.svg'
      }
    });
  }

  // Orange label next to the LW logo in the header.
 private setProjectTypeForAccount(accountId: string): void {
  this.accountsService.getBrandsList(accountId).subscribe(response => {
    if (response?.data?.message === 'Success') {
      let projectOptions: any[] = [];
      const brands = response.data.brands || [];

      const uniqueTypes = new Set<number>();
      brands.forEach((brand: any) => {
        const projectTypeId: number = Number(brand?.project_type);
        const addCondtion: boolean = (brand && brand?.project_info && brand?.project_info?.project_status && [1, 2, 3, 6].indexOf(parseInt(brand?.project_info?.project_status)) != -1 && brand?.show_on_dashboard != false) ? true : false;

        if (addCondtion && !uniqueTypes.has(projectTypeId)) {
          const projectOptionName = this.getProjectTypeName(projectTypeId);
          uniqueTypes.add(projectTypeId);
          if(projectOptionName) {
              projectOptions.push({ name: projectOptionName, project_type: projectTypeId });
          }
        }
      });

      // Only add "ALL" if there is more than one unique project type and more than one project
      if (brands.length > 1 && uniqueTypes.size > 1) {
        projectOptions.unshift({ name: 'ALL', project_type: 0 });
      }

      if (projectOptions.length) {
        this.selectedProjectType = projectOptions[0].name;
        this.helpersService.setProjectType(projectOptions[0]);
        this.projectTypeOptions = projectOptions;

        this.route.queryParams.subscribe((params) => {
          const isAccountId: boolean = params['account_id'];
          this.isShowProject = projectOptions.length > 0 && isAccountId;
        });
      } else {
        console.warn("No projects available for selected account.");
      }
    }
  });
}

  

  setProjectTypeForProject() {
    this.helpersService.appState.subscribe((response: any) => {
      if (response && !response.pending && response?.brandDetails?.project_type) {
        this.isShowProject = true;
        this.selectedProjectType = this.getProjectTypeName(response?.brandDetails?.project_type);
      }
    })
  }

  private getProjectTypeName(value: number): string {
    switch (value) {
      case 0: return 'ALL';
      case 1: return 'CX';
      case 2: return 'PX';
      case 3: return 'EX';
      case 4: return 'CX + PX';
      case 6: return 'AX';
      default: return '';
    }
  }

  onProjectTypeClick(event: any): void {
    this.isProjectTypeOpen = !this.isProjectTypeOpen;
    this.selectedProjectType = event ? event?.name : this.selectedProjectType;
    event?.name === undefined ? '' : this.helpersService.setProjectType(event);
  }

  setLoginTypeFromAccountDetails() {
    this.showChangePasswordButton = this.checkOTPAndSSOLogin() ? false : true;
  }

  checkOTPAndSSOLogin() {

    const ssoLogin = _.get(Helpers, "accountDetails.client_sso_config.is_enabled");
    if(ssoLogin) {
      return true;
    }

    const login =
    _.get(Helpers, "accountDetails.security_settings.authentication.login") ||
    _.get(Helpers, "brandDetails.security_settings.authentication.login");

    if (!login || !login.priority_list) {
        return false;
    }
    // Check if otp or sso is configured in priority list
    if (!login.priority_list.some(type => ["otp", "ldap"].includes(type))) {
        return false;
    }
    // Find the first enabled login type based on priority
    for (const type of login.priority_list) {
        if (login[type] && login[type].is_enabled) {
            return type === "otp" || type === "ldap";
        }
    }
    return false;
  }

  /////////////////////////////////////////////////////////////////////////////
  // Account name breadcrumb
  breadcrumbInitiate(): void {
    const accountDetails = Helpers?.accountDetails;
    const brandDetails = Helpers?.brandDetails;
    const statusCode = brandDetails?.project_info?.project_status || 0;
    this.restrictedDate = null;
    this.isHideAccountName = false;
    this.isHideProjectName = false;
    this.removeClickEventFromProject = false;
    this.removeClickEventFromAccount = false;
    const url: string = this.router.url;
    if (!url) return;



    if (url.includes('/account/project/')) {
      this.isProjectPage=true;
      this.isHideProjectName = false;
      this.breadcrumbAccount['name'] = accountDetails?.display_name || accountDetails?.name;
      this.breadcrumbAccount['account_id'] = accountDetails?._id;
      this.breadcrumbProject['name'] = brandDetails?.display_name || brandDetails?.name;
      this.breadcrumbProject['project_id'] = brandDetails?._id;
      this.breadcrumbProject['account_id'] = accountDetails?._id;
      this.breadcrumbProject['status'] = this.statusMap[statusCode] || null;
      if (this.breadcrumbProject['name']) {
        this.isHideAccountName = false;
        this.isHideProjectName = false;
      } else if (this.breadcrumbAccount['name']) {
        this.isHideAccountName = false;
      }
      this.isBreadcrumbVisible = true;
      this.breadcrumbTab = url.split('/')[3]?.split('?')[0];
      if (this.breadcrumbTab === 'scores') {
        this.removeClickEventFromProject = true;
      }
      const brandCreationDate:any = _.get(brandDetails, 'created_date', null);
      if (_.hasIn(brandDetails, 'project_info.restrict_date_from')) {
        this.restrictedDate = _.get(brandDetails, 'project_info.restrict_date_from', null);
      }else{
        this.restrictedDate = brandCreationDate;
      }
    } else if (url.includes('/accounts/')) {
      this.isBreadcrumbVisible = true;
      this.isHideProjectName = true;
      this.breadcrumbAccount['name'] = accountDetails?.display_name || accountDetails?.name;
      this.breadcrumbAccount['account_id'] = accountDetails?._id;
      this.breadcrumbTab = url.split('/')[2]?.split('?')[0];
      if (this.breadcrumbTab === 'home') {
        this.removeClickEventFromAccount = true;
      }
      if (this.breadcrumbAccount['name']) {
        this.isHideAccountName = false;
      }
      const accountCreationDate :any = _.get(accountDetails, 'created_date', null);
      if (_.hasIn(accountDetails, 'account_info.restrict_date_from')) {
        this.restrictedDate = _.get(accountDetails, 'account_info.restrict_date_from', null);
      }else{
        this.restrictedDate = accountCreationDate;
      }
    } else if(url.includes('/billing/')){
      this.isBreadcrumbVisible = true;
      this.isHideProjectName = true;
      this.isBillingDashboard = true;
      this.breadcrumbAccount['name'] = accountDetails?.display_name || accountDetails?.name;
      this.breadcrumbAccount['account_id'] = accountDetails?._id;
      this.breadcrumbTab = url.split('/')[2]?.split('?')[0];
      if (this.breadcrumbTab === 'overview') {
        this.removeClickEventFromAccount = true;
      }
      if (this.breadcrumbAccount['name']) {
        this.isHideAccountName = false;
      }
    } else {
      this.isBreadcrumbVisible = false;
    }
    this.isCalendarActive = true
  }

  getStatusClass(status?: string): string {
  if (!status) return '';
  return status.toLowerCase().replace(/\s+/g, '-'); // safe regex usage
}

  onBreadcrumbClick(event: any, type: string) {
    // Check if user has single project access
    const manager = _.get(Helpers, 'managerDetails.manager');
    if (manager) {
      const accessList = manager.manager_access || [];
      const verifiedAccessList = accessList.filter(
        a => a.is_verified && ('has_dashboard_access' in a ? a.has_dashboard_access : true)
      );

      // If exactly one access and not a super manager, prevent navigation
      if (verifiedAccessList.length === 1 && verifiedAccessList[0].manager_type !== 3) {
        return;
      }
    }

    // Otherwise proceed with normal navigation
    if (type === 'Account') {
      this.router.navigate(['/accounts/home'], {
        queryParams: {
          account_id: event?.account_id
        },
        // queryParamsHandling: 'merge'
      });
    } else if(type == 'billing'){
       this.router.navigate(['/billing/overview'], {
          queryParams: {
            id: event?.account_id
          }
        });
    }else if (type === 'Project') {
      const menuItem = this.helpersService.getActiveSideMenu(false, event?.account_id||event?.breadcrumbProject?.account_id);
      const activeTab = (menuItem && menuItem.length)?menuItem[0].tabKey : 'scores';
      if (event && event['account_id'] && event['project_id']) {
        this.router.navigate(['/account/project/'+activeTab], {
          queryParams: {
            account_id: event?.account_id,
            project_id: event?.project_id
          },
          // queryParamsHandling: 'merge'
        });
      } else if (event && event['breadcrumbProject'] && event['breadcrumbProject']) {
        this.router.navigate(['/account/project/'+activeTab], {
          queryParams: {
            account_id: event['breadcrumbProject']['account_id'],
            project_id: event['breadcrumbProject']['project_id']
          },
          // queryParamsHandling: 'merge'
        });
      }
    }
    this.handleClickOutsideBreadcrumbDropdown(event)
  }

  isDisplayBreadCrumbDropdown: boolean = false;
  openBreadCrumbDropdown() {
    this.isDisplayBreadCrumbDropdown = !this.isDisplayBreadCrumbDropdown;
    if (this.isDisplayBreadCrumbDropdown) {
      document.addEventListener('click', this.handleClickOutsideBreadcrumbDropdown);
    } else {
      document.removeEventListener('click', this.handleClickOutsideBreadcrumbDropdown);
    }
  }

  handleClickOutsideBreadcrumbDropdown = (event: MouseEvent) => {
    const dropdown = this.breadCrumbDropdown.nativeElement;
    if (dropdown && !dropdown.contains(event.target as HTMLElement)) {
      this.isDisplayBreadCrumbDropdown = false;
      document.removeEventListener('click', this.handleClickOutsideBreadcrumbDropdown);
    }
  };
  //////////////////////////////////////////////////////////////////////////////

  getManagerDetails() {
    // this.loginService.getManagerDetails().subscribe((response) => {
    const managerDetails = _.get(Helpers, 'managerDetails.manager', {})
    if (managerDetails) {
      this.email_address = managerDetails.email_address;
      this.userName = managerDetails.user_name;
      this.fullName = managerDetails?.name || (managerDetails?.first_name && managerDetails?.last_name ? `${managerDetails?.first_name} ${managerDetails?.last_name}` : '') || (this.userName === this.email_address ? null : this.userName);
      if (managerDetails?.name) {
        this.name_logo = this.getFirstAndLastLetters(managerDetails?.name);
      } else if (managerDetails?.first_name && managerDetails?.last_name) {
        this.name_logo = this.getFirstAndLastLetters(managerDetails?.first_name + ' ' + managerDetails?.last_name);
      } else if (managerDetails?.first_name) {
        this.name_logo = this.getFirstAndLastLetters(managerDetails?.first_name);
      } else {
        this.name_logo = this.getFirstAndLastLetters(this.email_address);
      }
    }
    // })
  }

  getFirstAndLastLetters(sentence: string): string {
    const words = sentence.trim().split(/\s+/);
    const firstLetter = words[0].charAt(0);
    if (words.length > 1) {
      const lastLetter = words[words.length - 1].charAt(0);
      return (firstLetter + lastLetter);
    } else {
      return firstLetter;
    }
  }

  menuHandler() {
    if (this.dropdown) {
      this.dropdown.close()
    }
  }

  // This method will check both new entered password if that is equal then v3 recaptcha token will generate and varify the same with google api. once the token varified then password will be changed.
  onSubmit() {
    this.isSubmitButtonDisable = true;
    const form = this.passwordResetForm.value;
    if (form.current_password === form.new_password && form.current_password === form.confirm_password) {
      this.isWrongPassword = true;
      this._toast.showPopup('ERROR', 'Error', "New and current password cannot be the same. Please choose another password.", 5000);
    } else {
      if (form.new_password && form.new_password === form.confirm_password) {
        this.googleRecaptchaService.initializeToken().subscribe((token: string | null) => {
          if (token) {
            const reqBody = {
              user_name: this.userName,
              old_password: form.current_password,
              new_password: form.new_password,
              g_recaptcha_response_v3: token
            };

            this.changePasswordService.changeNewPassword(reqBody).subscribe({
              next: (response) => {
                this.isSubmitButtonDisable = false;

                if (response && response.data?.code === 0) {
                  this.showModel = false;
                  this.closeModal();
                  this._toast.showPopup('SUCCESS', 'Success', 'Password updated. Please log in with the new password.', 5000);
                  setTimeout(() => {
                    this.router.navigate([APP_CONST.ROUTE_LOGIN]);
                  }, 6000);
                } else if (response?.data?.code === 1 && response.data.error_message === "Invalid old password.") {
                  this.invalidCurrentPassword = true;
                  this._toast.showPopup('ERROR', 'Error', "Your Current Password is not correct.", 5000);
                } else if (response?.data?.code === 405) {
                  this._toast.showPopup('ERROR', 'Error', "The Entered New Password did not meet the security requirements. Please choose a different password.", 5000);
                } else if (response?.data?.error_message) {
                  this._toast.showPopup('ERROR', 'Error', response.data.error_message, 5000);
                } else {
                  this._toast.showPopup('ERROR', 'Error', "Error while changing the password.", 5000);
                }
              },
              error: (error) => {
                console.error('Error while changing the password:', error);
                this._toast.showPopup('ERROR', 'Error', 'Error while changing the password.', 5000);
                this.isSubmitButtonDisable = false;
              }
            });
          }
        });       
      } else {
        this.isWrongPassword = true;
        this._toast.showPopup('ERROR', 'Error', 'The New Password and the Confirm Password fields do not match.', 5000);
      }
    }
  }

  toggleDropdown(event: any) {
    event.preventDefault();
    this.dropdownVisible = !this.dropdownVisible;
    this.isProfileDropdownVisible = false
    if (this.dropdownVisible) {
      document.addEventListener('click', this.handleClickOutside);
  
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  handleClickOutside = (event: MouseEvent) => {
    const dropdown = this.threeDotContainer.nativeElement;
    if (dropdown && !dropdown.contains(event.target as HTMLElement)) {
      this.dropdownVisible = false;
      document.removeEventListener('click', this.handleClickOutside);
    }
  };


  toggleProfile() {
    this.isProfileDropdownVisible = !this.isProfileDropdownVisible;
    if (this.isProfileDropdownVisible) {
      document.addEventListener('click', this.handleClickOutsideProfile);
    } else {
      document.removeEventListener('click', this.handleClickOutsideProfile);
    }
  }

  handleClickOutsideProfile = (event: MouseEvent) => {
    const dropdown = this.userProfile.nativeElement;
    if (dropdown && !dropdown.contains(event.target as HTMLElement)) {
      this.isProfileDropdownVisible = false;
      document.removeEventListener('click', this.handleClickOutsideProfile);
    }
  };

  getAccountDetail(accountId: string): void {
    const accountDetails = _.get(Helpers, 'accountDetails', {})
    if (accountDetails && accountDetails['_id'] && accountDetails['_id'] == accountId) {
      this.accountsDetails = accountDetails;
    } else {
      this.accountsService.getAccountDetail(accountId).subscribe(
        (response) => {
          this.accountsDetails = response.data.account;
        },
        (error) => {
          console.error('Error during account details API call:', error);
        }
      );
    }
  }

  getBrandDetail(projectId: string): void {
    const brandDetails = _.get(Helpers, 'brandDetails', {})
    if (brandDetails && brandDetails['_id'] && brandDetails['_id'] == projectId) {
      this.accountsService.setBrandDetails(brandDetails)
      if (brandDetails && brandDetails['help_resources'] && brandDetails['help_resources'].length > 0) {
        const list = brandDetails['help_resources'].filter(ele => ele._id == 'preview_v2_link');
        if (list && list.length > 0) {
          this.isProjectLevelConversationPreview = true;
          this.conversationPreviewURL = list[0]['url'];
        }
      }
    } else {
      this.accountsService.getBrandDetail(projectId).subscribe(
        (response) => {
          if (response.code == 0 && _.hasIn(response, 'data.brand')) {
            this.accountsService.setBrandDetails(response?.data?.brand)
            if (response.data.brand && response.data.brand['help_resources'] && response.data.brand['help_resources'].length > 0) {
              const list = response.data.brand['help_resources'].filter(ele => ele._id == 'preview_v2_link');
              if (list && list.length > 0) {
                this.isProjectLevelConversationPreview = true;
                this.conversationPreviewURL = list[0]['url'];
              }
            }
          }
        },
        (error) => {
          console.error('Error during account details API call:', error);
        }
      );
    }
  }

  openPreviewURL() {
    this.dropdownVisible = !this.dropdownVisible;
    const newWindow = window.open(this.conversationPreviewURL, '_blank');
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Failed to open new window. It may have been blocked by a popup blocker.");
    }

  }

  updateFullScreenButtonText() {
    this.fullScreenButtonText = this.isFullScreen ? 'Exit Fullscreen' : 'View Fullscreen';
  }

  exitFullScreenListener() {
    document.addEventListener('fullscreenchange', () => {
      this.isFullScreen = !!document.fullscreenElement;
      this.updateFullScreenButtonText();
    });
  }

  toggleFullScreen() {
    this.dropdownVisible = !this.dropdownVisible;
    const doc = window.document;
    const docEl = doc.documentElement;

    const requestFullScreen =
      docEl.requestFullscreen ||
      docEl['webkitRequestFullscreen'] ||
      docEl['mozRequestFullScreen'] ||
      docEl['msRequestFullscreen'];

    const exitFullScreen =
      doc.exitFullscreen ||
      doc['webkitExitFullscreen'] ||
      doc['mozCancelFullScreen'] ||
      doc['msExitFullscreen'];

    if (!this.isFullScreen) {
      // Enter full screen mode
      if (requestFullScreen) {
        requestFullScreen.call(docEl);
      }
      this.isFullScreen = true;
    } else {
      // Exit full screen mode
      if (exitFullScreen) {
        exitFullScreen.call(doc);
      }
      this.isFullScreen = false;
    }

    // Update the text based on full-screen state
    this.updateFullScreenButtonText();

    // Start listening for full-screen change events
    this.exitFullScreenListener();
  }
  toggleSignedInAsVisibility() {
    this.headerService.toggleSignedInAsButtonVisibility(!this.signedInAsVisible);
  }

  toggleChangeAccessLevelVisibility() {
    this.headerService.toggleChangeAccessLevelButtonVisibility(!this.changeAccessLevelVisible);
  }
  changeAccessLevel() {
    this.isProfileDropdownVisible = !this.isProfileDropdownVisible;
    this.changeAccessLevelContainerVisible = !this.changeAccessLevelContainerVisible;
  }
  doOperation(headerState) {
    if (!headerState.changeAccessLevelContainerVisible) {
      this.changeAccessLevelContainerVisible = false;
    }
  }
}